<div class="container">
    <h2 class="my-2">{{ partnerName }}</h2>
    <div class="d-flex flex-column flex-md-row align-items-center gap-2 my-2">
        <div class="col-8 col-md-4 col-xl-2 mr-4 my-2">
            <app-search-box (search)="onSearch($event)"></app-search-box>
        </div>
        <div>
            <button class="btn" (click)="onAddItem()">
                <img src="assets/icon/plus.png" />
                <span class="mx-1">{{ 'common.add' | translate }}</span>
            </button>
        </div>
    </div>

    <table *ngIf="showTable" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover" style="width: 100%"></table>

    <ng-template #actionsRef let-data="adtData" let-emitter="captureEvents">
        <app-edit [data]="data" (emitter)="emitter($event)"></app-edit>
    </ng-template>
    <ng-template #imgWidth75pxRef_couponImage let-data="adtData">
        <img-with-src-75px [data]="data" [propertyName]="'couponImageUrl'"></img-with-src-75px>
    </ng-template>
    <ng-template #imgWidth75pxRef_couponGif let-data="adtData">
        <img-with-src-75px [data]="data" [propertyName]="'couponGifUrl'"></img-with-src-75px>
    </ng-template>
</div>
